module.exports = __webpack_public_path__ + "img/home.cbcd4ee0.svg";